export default "https://cdn-static.gokick.com/assets/9c92702f75f0b67707db9d869eecabb5f21facb9/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";